import React from 'react';
import {
  Flex,
  Box,
  Text,
  Button,
  Icon,
} from '@chakra-ui/react';
import {
  NewKBCallForm,
  NewKBCallHistory,
  NewKBCustomerNotes,
  NewKBWhatsAppIntegration,
  NewKBCallChecklist,
} from './call-components'; // Assuming call-components is in the same relative path

const NewKBRecordCallModalCallContent = ({
  lead,
  callHistory,
  isLoadingHistory,
  onRefreshCallHistory,
  customerNotes,
  setCustomerNotes,
  onSaveCustomerNotes,
  callStatus,
  setCallStatus,
  rescheduleTime,
  setRescheduleTime,
  callNotes,
  setCallNotes,
  createTask,
  setCreateTask,
  taskData,
  setTaskData,
  setIsWhatsAppGroupInviteModalOpen,
  setIsWhatsAppGroupCreateModalOpen,
  embedded = false, // Keep embedded prop if styling depends on it directly within this content
  useAiExtraction, // AI extraction toggle state
  onAiExtractionChange, // AI extraction toggle handler
}) => {
  return (
    <Flex gap={4} h={embedded ? "auto" : "630px"}>
      {/* WhatsApp Chat Panel */}
      <Box w="320px" borderRight="1px" borderColor="gray.200" h="100%" overflowY="hidden">
        <Flex direction="column" h="100%">
          <NewKBWhatsAppIntegration
            phoneNumber={lead?.phone?.replace(/[^0-9]/g, '')}
            whatsappGroup={lead?.whatsappGroup}
            whatsappGroupName={lead?.whatsappGroupName}
          />

          {lead?._id && (
            <Flex m={2} gap={2} flexDirection="column" width="50%">
              <Button
                size="xs"
                colorScheme="green"
                variant="outline"
                leftIcon={<Icon viewBox="0 0 24 24" boxSize="3">
                  <path
                    fill="currentColor"
                    d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z"
                  />
                </Icon>}
                height="24px"
                width="100%"
                onClick={() => setIsWhatsAppGroupInviteModalOpen(true)}
                fontSize="0.7rem"
                padding="2px 8px"
                justifyContent="flex-start"
              >
                {lead?.whatsappGroup ? "Change Group added to Lead" : "Add Group via Invite"}
              </Button>
              
              <Button
                size="xs"
                colorScheme="teal"
                variant="outline"
                leftIcon={<Icon viewBox="0 0 24 24" boxSize="3">
                  <path
                    fill="currentColor"
                    d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23z"
                  />
                </Icon>}
                height="24px"
                width="100%"
                onClick={() => setIsWhatsAppGroupCreateModalOpen(true)}
                fontSize="0.7rem"
                padding="2px 8px"
                justifyContent="flex-start"
              >
                Create New Group
              </Button>
            </Flex>
          )}

          {!lead?._id && (
            <Box p={3} bg="orange.50" borderRadius="md" mt={2}>
              <Text fontSize="sm" color="orange.700">
                Save the lead to enable call history and WhatsApp features.
              </Text>
            </Box>
          )}
        </Flex>
      </Box>

      {/* Main Content Panel */}
      <Flex flex={1} direction="column" h="100%" overflowY="auto">
        <Flex flex={1} mb={4}>
          {/* Left Column - Call form and history */}
          <Box flex={2} mr={4}>
            <NewKBCallForm
              callStatus={callStatus}
              setCallStatus={setCallStatus}
              rescheduleTime={rescheduleTime}
              setRescheduleTime={setRescheduleTime}
              callNotes={callNotes}
              setCallNotes={setCallNotes}
              lead={lead}
              createTask={createTask}
              setCreateTask={setCreateTask}
              taskData={taskData}
              setTaskData={setTaskData}
              useAiExtraction={useAiExtraction}
              onAiExtractionChange={onAiExtractionChange}
            />

            <NewKBCallHistory
              callHistory={callHistory}
              isLoading={isLoadingHistory}
              onRefresh={onRefreshCallHistory}
            />
          </Box>

          {/* Middle Column - Customer notes */}
          <Box flex={1} mr={4}>
            <NewKBCustomerNotes
              notes={customerNotes}
              setNotes={setCustomerNotes} // Assuming NewKBCustomerNotes uses setNotes
              onSave={onSaveCustomerNotes} // Assuming NewKBCustomerNotes uses onSave
              lead={lead}
            />
          </Box>

          {/* Right Column - Call Checklist */}
          <Box flex={1} w="220px">
            <NewKBCallChecklist />
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NewKBRecordCallModalCallContent;